import React, {useState} from 'react';

const DescriptiveLink = ({title, isUnderlined, callback}) => {
  return (
    <span className={`descriptive-link ${isUnderlined ? 'underlined' : ''}`} onClick={callback}>
      {title}
    </span>
  );
};

export default DescriptiveLink;
